import { createContext, useState, useCallback, ReactNode } from 'react';

interface TourContextType {
  isActive: boolean;
  currentStep: number;
  startTour: () => void;
  nextStep: () => void;
  prevStep: () => void;
  skipTour: () => void;
  hasCompletedTour: boolean;
}

export const TourContext = createContext<TourContextType>({
  isActive: false,
  currentStep: 0,
  startTour: () => {},
  nextStep: () => {},
  prevStep: () => {},
  skipTour: () => {},
  hasCompletedTour: false,
});

export function TourProvider({ children }: { children: ReactNode }) {
  const [isActive, setIsActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [hasCompletedTour, setHasCompletedTour] = useState(() => {
    return localStorage.getItem('dratento_tour_completed') === 'true';
  });

  const startTour = useCallback(() => {
    setCurrentStep(0);
    setHasCompletedTour(false);
    setIsActive(true);
  }, []);

  const nextStep = useCallback(() => {
    setCurrentStep(prev => prev + 1);
  }, []);

  const prevStep = useCallback(() => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  }, []);

  const skipTour = useCallback(() => {
    setIsActive(false);
    setCurrentStep(0);
    setHasCompletedTour(true);
    localStorage.setItem('dratento_tour_completed', 'true');
  }, []);

  return (
    <TourContext.Provider value={{ isActive, currentStep, startTour, nextStep, prevStep, skipTour, hasCompletedTour }}>
      {children}
    </TourContext.Provider>
  );
}
